<template>
  <v-app>
    <v-layout class="body">
      <NavigationMenuRevamp data-test-id="new-layout-navigation-menu" />

      <v-main data-test-id="new-layout-main" max-height="100vh" class="overflow-auto">
        <AppGlobalProgressBar data-test-id="new-layout-global-progress-bar" />
        <AppSnackbar data-test-id="new-layout-app-snackbar" />

        <AccessDenied
          data-test-id="new-layout-access-denied"
          v-model:is-modal-visible="isAccessDeniedModalVisible"
          :access-denied-message="accessDeniedMessage"
        />

        <v-container data-test-id="new-layout-container" class="px-8 py-6" fluid>
          <slot />
        </v-container>
      </v-main>
    </v-layout>
  </v-app>
</template>

<script lang="ts" setup>
import AccessDenied from '@/components/access-denied/AccessDenied.vue';
import AppGlobalProgressBar from '@/components/common/app-global-progress-bar/AppGlobalProgressBar.vue';
import AppSnackbar from '@/components/common/AppSnackbar.vue';
import NavigationMenuRevamp from '@/components/navigation-menu/NavigationMenuRevamp.vue';
import useAccessDenied from '@/composable/access-denied/useAccessDenied';

const { isAccessDeniedModalVisible, accessDeniedMessage } = useAccessDenied();
</script>
